export const LINKEDIN_PROFILE_URL_RE =
  /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[A-Za-z0-9_\-.%]+\/?$/i;

export function isValidLinkedinProfileUrl(value: string): boolean {
  return LINKEDIN_PROFILE_URL_RE.test(value.trim());
}

/** What the application form shows before the field, so applicants type
 *  only their handle. */
export const LINKEDIN_PROFILE_PREFIX = "linkedin.com/in/";

/** A profile handle: the part after `linkedin.com/in/`. */
const LINKEDIN_HANDLE_RE = /^[A-Za-z0-9_\-.%]{1,100}$/;

/**
 * The handle from whatever the applicant typed or pasted: just the handle
 * (`anna-svensson`, `@anna-svensson`), or a whole profile link, with or
 * without `https://`, `www.` or a country subdomain, a trailing slash, or a
 * query string LinkedIn's share button adds.
 */
export function linkedinHandleFromInput(value: string): string {
  const raw = value.trim();
  const fromUrl =
    /^(?:https?:\/\/)?(?:[a-z]{2,3}\.|www\.)?linkedin\.com\/in\/([^/?#\s]+)/i.exec(
      raw
    );
  const handle = fromUrl ? fromUrl[1] : raw.replace(/^@/, "");
  return handle.replace(/\/+$/, "");
}

export function isValidLinkedinHandle(handle: string): boolean {
  return LINKEDIN_HANDLE_RE.test(handle);
}

/** The profile link stored with the application. */
export function linkedinProfileUrl(handle: string): string {
  return `https://www.${LINKEDIN_PROFILE_PREFIX}${handle}`;
}
